<template>
	<div>
		<div class="contact">
			<div v-html="detail.content"></div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				id:'',
				detail:{}
			}
		},
		created(){
			this.id = this.$route.query.id
			this.getSystem()
		},
		methods:{
			getSystem(){
				this.$api.post('/news/getDetails',{id:this.id},res=>{
					if(res.code == 1){
						this.detail = res.data;
						this.$api.post('/news/read',{id:this.id},res=>{
							if(res.code == 1){
								console.log(0)
							}
						})
					}
				})
			},
			read(){
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.contact{
		width: 1200px;
		margin: 0 auto;
		padding: 20px;
	}
</style>